import i18n from '@/lib/language'
/**
 * 100全部
 *3--'本月',
 *4--'本年',
 *2--'全部',
 *1--'昨日',
 *2--'本周'
 *5--'今日'
 *6--'近七天'
 *7--'近一月'
 *8--'近一年'
      "1704": "昨日",
      "1705": "本周",
      "1706": "本月",
      "1707": "本年",
      "1708": "今日",
      "1709": "近七天",
      "1710": "近一月",
      "1711": "近一年"
 */
// 总览日期
export const overviewIndex = [
  { key: 100, value: i18n.t('message["904"]') },
  { key: 4, value: i18n.t('message["1707"]') },
  { key: 3, value: i18n.t('message["1706"]') },
  { key: 2, value: i18n.t('message["1705"]') },
  { key: 1, value: i18n.t('message["1704"]') }
]
// 信息接待/跟进趋势日期
export const overviewTendency = [
  { key: 8, value: i18n.t('message["1711"]') },
  { key: 7, value: i18n.t('message["1710"]') },
  { key: 6, value: i18n.t('message["1709"]') }
]
// 信息接待/数据跟进数据日期
export const overviewData = [
  { key: 4, value: i18n.t('message["1707"]') },
  { key: 3, value: i18n.t('message["1706"]') },
  { key: 2, value: i18n.t('message["1705"]') },
  { key: 5, value: i18n.t('message["1708"]') }
]
/**
 * 格式化趋势数据
 * @param {*} array
 */
export const formateTendencyData = array => {
  const json = {
    category: [],
    data: []
  }
  if (Array.isArray(array)) {
    array.map(value => {
      json.category.push(value.name)
      json.data.push(value.num)
    })
  }
  return json
}
/**
 * 格式化表头数据格式
 * @param {*} array
 */
export const formateTableColmunsData = array => {
  const json = {
    colmunsArray: [],
    colmuns: []
  }
  if (Array.isArray(array)) {
    array.map(value => {
      json.colmunsArray.push(value.sortId)
      json.colmuns.push({
        title: value.name,
        key: value.sortId,
        dataIndex: value.sortId
      })
    })
  }
  return json
}

/**
 * 格式化表格内容数据
 * @param {*} array
 * @param {*} colmunsArray
 * @param {*} flag
 */
export const formateTableDatas = (array, colmunsArray, flag) => {
  let tempArray = []
  if (Array.isArray(array)) {
    array.map(value => {
      let json = {}
      value.map((values, index) => {
        if (flag) {
          if (index === 0) {
            json[colmunsArray[index]] = i18n.t('message["1670"]')
          } else {
            json[colmunsArray[index]] = values
          }
        } else {
          json[colmunsArray[index]] = values
        }
      })
      tempArray.push(json)
    })
  }
  return tempArray
}
// 移动端
/**
 * 格式化日期组件数据
 * @param {*} array
 */
export const formatePickerData = array => {
  let tempArray = []
  if (Array.isArray(array)) {
    for (let i = array.length - 1; i >= 0; i--) {
      const { key, value } = array[i]
      const json = {
        text: value,
        value: key
      }
      tempArray.push(json)
    }
  }
  return tempArray
}
/**
 * 格式化日期组件数据
 * @param {*} array
 */
export const getDateText = (array, item) => {
  let json = {}
  if (Array.isArray(array)) {
    array.some(value => {
      if (value.value === item) {
        json = value
        return true
      }
    })
  }
  return json
}
/**
 * 格式化饼图数据
 * @param {*} object
 */
export const formatePieDatas = object => {
  if (!object.total) return {}
  const json = {
    total: object.total,
    data: []
  }
  if (Array.isArray(object.from)) {
    object.from.map(value => {
      const { name, num, per } = value
      const y = per.substring(0, per.length - 1).substring(0, 4) * 1
      json.data.push({ name, num, y: y })
    })
  }
  return json
}

/* 格式化数字 万亿单位 */
export const formateNumUnit = (num) => {
  if (num === undefined) return

  let newNum
  let unit

  if (num >= 10000 * 10000 * 10000) {
    // 万亿
    unit = i18n.t('message["1249"]')
    newNum = num / (10000 * 10000 * 10000)
  } else if (num >= 10000 * 10000) {
    // 亿
    unit = i18n.t('message["1487"]')
    newNum = num / (10000 * 10000)
  } else if (num >= 10000) {
    // 万
    unit = i18n.t('message["1243"]')
    newNum = num / 10000
  } else {
    unit = ''
    newNum = num
  }
  // console.log(newNum)
  newNum = newNum.toString()
  if (newNum.indexOf('.') !== -1) {
    let arr = newNum.split('.')
    if (arr[1].length >= 2) {
      newNum = fomatFloat(newNum, 2) // 保留两位小数
    }
  }
  return {
    num: newNum,
    unit
  }
}

// 千位逗号
export const toThousands = (num) => {
  return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
}
/*
 * formatMoney(s,type)
 * 功能：金额按千位逗号分隔
 * 参数：s，需要格式化的金额数值.
 * 参数：type,判断格式化后的金额是否需要小数位.
 * 返回：返回格式化后的数值字符串.
 */
export const formatMoney = (s, type) => {
  if (/[^0-9\.]/.test(s)) { return '0.00' }
  if (s == null || s === 'null' || s === '') { return '0.00' }
  s = s.toString().replace(/^(\d*)$/, '$1.')
  s = (s + '00').replace(/(\d*\.\d\d)\d*/, '$1')
  s = s.replace('.', ',')
  var re = /(\d)(\d{3},)/
  while (re.test(s)) { s = s.replace(re, '$1,$2') }
  s = s.replace(/,(\d\d)$/, '.$1')
  if (type === 0) {
    var a = s.split('.')
    if (a[1] === '00') {
      s = a[0]
    }
  }
  return s
}

export const formatMoney2 = (moneyStr) => {
  // 先将数值取两位小数
  let str = (Math.round(moneyStr * 100) / 100).toString()
  // 找到小数点的下标
  let pointIdx = str.indexOf('.')
  // 如果没有小数点
  if (pointIdx < 0) {
    // 将数值进行千位符转换
    str = str.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
    // 添加小数点
    // pointIdx = str.length
    // str += '.'
  } else { // 如果有小数点
    // 取整数部分, 也可以用 parseInt
    let int = str.substr(0, pointIdx)
    // 整数部分进行千位符转换
    int.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
  }
  // 如果没有小数点,用 0 补全
  /* while (str.length <= pointIdx + 2) {
    str += '0'
  } */
  return str
}

// num为传入的值，n为保留的小数位
export const fomatFloat = (num, n) => {
  let f = parseFloat(num)
  if (isNaN(f)) {
    return false
  }
  f = Math.round(num * Math.pow(10, n)) / Math.pow(10, n) // n 幂
  let s = f.toString()
  /* var rs = s.indexOf('.')
  // 判定如果是整数，增加小数点再补0
  if (rs < 0) {
    rs = s.length
    s += '.'
  }
  while (s.length <= rs + n) {
    s += '0'
  } */
  return s
}
